export default {
  "menu": {
    "dashboard": "Dashboard",
    "apps": "Apps",
    "orders": "Orders",
    "api": {
      "title": "API",
      "apiApps": "API apps",
      "callbacks": "Callbacks",
      "requests": "Requests"
    },
    "profile": {
      "title": "Profile",
      "updateProfile": "Update profile",
      "updatePassword": "Update password"
    },
    "payoutSettings": {
      "title": "Payout settings",
      "withdrawals": "Withdrawals",
      "wallets": {
        "title": "Wallets",
        "bitcoin": "Bitcoin",
        "ethereum": "Ethereum",
        "cardano": "ADA (Cardano)"
      }
    }
  },
  "headerMenu": {
    "profile": "Profile",
    "logout": "Log out"
  },
  "updateProfile": {
    "title": "Update profile",
    "fullName": "Full name",
    "email": "Email",
    "phoneCountry": "Phone country code",
    "phone": "Phone",
    "timezone": "Timezone",
    "address": "Address"
  },
  "updatePassword": {
    "title": "Update password",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "passwordConfirmation": "Password confirmation"
  },
  "button": {
    "edit": "Edit",
    "clear": "Clear",
    "submit": "Submit",
    "save": "Save",
    "cancel": "Cancel"
  }
}